import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useLaneStyles = makeStyles(() => {
  return createStyles({
    connectButton: {
      backgroundColor: '#28aae1',
      borderRadius: '4px',
      color: '#ffffff',
      cursor: 'pointer',
      paddingLeft: '1px',
      paddingTop: '2px',
      fontSize: '14px',
      fontWeight: 500,
    },
  });
});

export default useLaneStyles;
